module.exports = __webpack_public_path__ + "img/cancel.5a161013.svg";